import { Component, inject, OnInit } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { ActivatedRoute, RouterModule, UrlSegment ,Router} from '@angular/router';
import { CdkObserveContent } from "@angular/cdk/observers";
import { ChangeDetectorRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-menu',
  imports: [CommonModule, MatListModule, RouterModule, MatButtonModule, MatMenuModule ],
  templateUrl: './menu.html',
  styleUrl: './menu.scss',
})
export class Menu {
  public showMenu: boolean = true;
  public router = inject(Router);
  constructor() {
    const token = localStorage.getItem('access_token');
    // if (!token) {
    //   this.showMenu = false;
    // } else {
    //   this.showMenu = true;
    // }
  }

}
